/**
 * Vendors Reducer
 * Initial state and action handler for vendors list
 */

const initialState = { data: [], loading: true };

export const GetAllVendorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "get_all_vendors":
      return {
        data: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

// Initial vendor data structure (for form default values)
export const vendorDataState = {
  VendorId: 0,
  VendorName: null,
  VendorCategory: null,
  ContactPersonName: null,
  ContactEmail: null,
  ContactPhone: null,
  Address: null,
  City: null,
  Country: null,
  TaxId: null,
  Status: "Active",
};
